(function () {
  function findImage(link) {
    var wrapper = link.closest('.card-wrapper');
    if (!wrapper) return null;
    return wrapper.querySelector('.card__swatch-hover-image');
  }

  document.addEventListener('mouseover', function (event) {
    var link = event.target.closest('.card__swatch-list-item');
    if (!link) return;
    var imageUrl = link.getAttribute('data-variant-image');
    if (!imageUrl) return;
    var img = findImage(link);
    if (!img) return;
    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.currentSrc || img.src;
    }
    img.src = imageUrl;
    img.srcset = '';
  });

  document.addEventListener('mouseout', function (event) {
    var link = event.target.closest('.card__swatch-list-item');
    if (!link) return;
    var img = findImage(link);
    if (!img || !img.dataset.originalSrc) return;
    img.src = img.dataset.originalSrc;
    img.removeAttribute('srcset');
  });

  document.addEventListener('focus', function (event) {
    var link = event.target.closest && event.target.closest('.card__swatch-list-item');
    if (!link) return;
    var imageUrl = link.getAttribute('data-variant-image');
    if (!imageUrl) return;
    var img = findImage(link);
    if (!img) return;
    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.currentSrc || img.src;
    }
    img.src = imageUrl;
  }, true);

  document.addEventListener('blur', function (event) {
    var link = event.target.closest && event.target.closest('.card__swatch-list-item');
    if (!link) return;
    var img = findImage(link);
    if (!img || !img.dataset.originalSrc) return;
    img.src = img.dataset.originalSrc;
  }, true);
})();
